// DS: i6.11
import React from 'react';
import IconWrap from '../IconWrap';
const Expand = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9.315 13.295a.997.997 0 011.493 1.316l-.083.094L6.43 19h2.59a1 1 0 01.117 1.993L9.02 21h-5a1 1 0 01-.993-.883L3.02 20v-5a1 1 0 011.993-.117L5.02 15v2.59l4.295-4.295zM20.02 3a1 1 0 01.993.883L21.02 4v5a1 1 0 01-1.993.117L19.02 9V6.41l-4.295 4.295a.997.997 0 01-1.493-1.316l.083-.094L17.61 5h-2.59a1 1 0 01-.117-1.993L15.02 3h5z"
    })));
};
Expand.displayName = 'Expand';
export default Expand;

//# sourceMappingURL=Expand.js.map